import './index.scss';

import React from 'react';
import PropTypes from 'prop-types';

const ImageGallery = ({images, selectedImage, onSelect}) => {
	if (!images || images.length === 0) {
		return (
			<div className="image-gallery image-gallery--empty">
				<p>No existing images available</p>
			</div>
		);
	}

	return (
		<div className="image-gallery">
			<div className="image-gallery__grid">
				{images.map((imageUrl, index) => (
					<button
						key={`${imageUrl}-${index}`}
						type="button"
						className={`image-gallery__item ${selectedImage === imageUrl ? 'image-gallery__item--selected' : ''}`}
						onClick={() => onSelect(imageUrl)}
					>
						<img src={imageUrl} alt={`Gallery item ${index + 1}`} />
					</button>
				))}
			</div>
		</div>
	);
};

ImageGallery.propTypes = {
	images: PropTypes.arrayOf(PropTypes.string).isRequired,
	selectedImage: PropTypes.string,
	onSelect: PropTypes.func.isRequired
};

ImageGallery.defaultProps = {
	selectedImage: null
};

export default ImageGallery;
